import { FC } from 'react';
import type { SwiperOptions } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import ArticleCard, { ArticleCardProps } from '@/components/article-card/article-card';
import { Article } from '@/types/article';

import styles from './articles-carousel.module.scss';

export const options: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 24,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: true,
    breakpoints: {
        992: {
            watchOverflow: true,
        },
    },
};

export interface RoomstayBlogFeaturedArticlesProps {
    articles: Article[];
    ArticleCardProps?: Omit<ArticleCardProps, 'article'>;
}

const ArticlesCarousel: FC<RoomstayBlogFeaturedArticlesProps> = ({ articles, ArticleCardProps }) => {
    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <Swiper {...options}>
                    {articles.map((article) => (
                        <SwiperSlide key={article.id}>
                            <div className={styles.item}>
                                <ArticleCard dark key={article.id || Math.random()} article={article} {...ArticleCardProps} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default ArticlesCarousel;
